<template>
  <a href="./report-pl.pdf" target="_blank" rel="noopener" class="get-report button">
    Pobierz Raport
    <img src="../assets/img/arrow.svg" class="arrow arrow--no-hover" />
    <img src="../assets/img/arrow-hover.svg" class="arrow arrow--hover" />
  </a>
</template>

<script>
export default {
  name: "GetReport"
};
</script>


<style lang="scss">
.get-report {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  position: fixed;
  top: $screen-gutter-top - 9px;
  left: calc(100% - #{$main-width} + #{$main-gutter-left});

  .arrow {
    height: 17px;
    width: auto;

    &--hover {
      display: none;
      margin-right: 9px;
    }
  }

  &:hover {
    color: $white-color !important;

    .arrow {
      &--no-hover {
        display: none;
      }

      &--hover {
        display: block;
      }
    }
  }
}
</style>
